import React from "react";

const MemberShip = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        B.
        <span className="text-[#01A7D1] "> MEMBERSHIP AND ACCESSIBILITY</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. License to Access
        </h1>
        Yostel hereby grants you a non-exclusive, revocable license to use the
        Platform as set forth in the Terms of Use; provided, however, that (i)
        you will not copy, distribute, or make derivative works of the Platform
        in any medium without Yostel's prior written consent; (ii) you will not
        alter or modify any part of the Platform other than as may be reasonably
        necessary to use the Platform for its intended purposes or if so
        requested by Yostel; and (iii) you will otherwise act in accordance with
        the terms and conditions of the Terms of Use and in accordance with all
        applicable laws in India.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Membership Eligibility Criteria
        </h1>
        You represent, acknowledge and agree that you are either (i) at least 18
        years of age or (ii) you as a parent / guardian agree to be bound as
        well as agree that your ward shall be bound and you shall cause your
        ward to be bound by the present Terms of Use, and that: (a) all
        registration information that you submit is truthful and accurate, (b)
        you will maintain the accuracy of such information, and (c) your use of
        the Platform and Services offered through this Platform do not violate
        any applicable law or regulation. Your Account (defined below) may be
        terminated without warning if Yostel, at its sole discretion, believes
        that you are violating the terms of this Terms of Use or that you are
        not complying with any applicable laws, rules or regulations in India.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        To access and participate in the Platform, you will need to create a
        password-protected account ("Account"). To create an account, you must
        submit your name, email address and phone number, through the account
        registration page on the Platform and create a password. You will also
        have the ability to provide additional / optional information, which is
        not required to register for an account but may be helpful to Yostel in
        providing you with a more customized experience while using the
        Platform. You may at the discretion of Yostel be also provided with the
        option of registering for an Account using your existing social network
        account and log-in credentials (your "Third-Party Site Password"). You
        are solely responsible for safeguarding your Yostel password and, if
        applicable, your Third-Party Site Password (collectively, "Passwords")
        at all times. You shall be solely responsible for all activity that
        occurs on your Account and you shall notify Yostel immediately of any
        breach of security or any unauthorized use of your Account. Similarly,
        you shall never use another member’s Account without Yostel’s
        permission. You agree that you will not misrepresent yourself or
        represent yourself as another user of the Platform and/or the Services
        offered through the Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You hereby expressly acknowledge and agree that you yourself and not
        Yostel will be liable for your losses, damages etc. (whether direct or
        indirect) caused by an unauthorized use of your Account. Notwithstanding
        the foregoing, you may be liable for the losses of Yostel or others due
        to such unauthorized use. An Account holder is herein referred to as a
        "Registered User."
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. Additional Policies
        </h1>
        Your access to, use of, and participation in the Platform is subject to
        the Terms of Use and all applicable Yostel’s regulations, guidelines and
        additional policies that Yostel may set forth from time to time,
        including without limitation, a copyright policy and any other
        restrictions or limitations that Yostel publishes on the Platform (the
        "Additional Policies"). You hereby agree to comply with the Additional
        Policies and your obligations thereunder at all times. You hereby
        acknowledge and agree that if you fail to adhere to any of the terms and
        conditions of this Agreement or documents referenced herein, including
        the Account Policies, membership eligibility criteria or Additional
        Policies, Yostel, in its sole discretion, may terminate your Account at
        any time without prior notice to you as well as claim damage or initiate
        appropriate legal proceedings, if necessary.
      </p>
    </div>
  );
};

export default MemberShip;
